import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { useVuelidate } from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import { mapState, mapActions } from "pinia";
import { resendConfirmationEmail } from "../../components/loginAPI";
import { useKeyEnterPressed } from "@wkComposables/useKeyEnterPressed";
//@ts-ignore
import { useValidator } from "@wkComposables/useValidator";
//@ts-ignore
import BaseBtModal from "../BaseBtModal.vue";
//@ts-ignore
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
//@ts-ignore
import BaseComplexToggle from "@vueEntry/UIKitComponents/BaseComplexToggle.vue";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import BaseBadge from "@vueEntry/UIKitComponents/BaseBadge.vue";
import { isNotificationDenied } from "@utils/NotificationsUtils";
//@ts-ignore
import { decodeTextWithEntities } from "@utils/StringUtils";
import { MAP_TILER_APIKEY, MAP_TILER_STYLE, MAP_TILER_VALUATION_CUSTOM_MOBILE_ZOOM, MAP_TILER_VALUATION_ZOOM, MAP_TILER_VALUATION_IMAGE_SIZE
//@ts-ignore
} from "@wkWebSrc/js/components/variables";
//@ts-ignore
import { getPlaceFromPlaceID } from "@services/geographyAPI";
import { PLACE_TYPE } from "@customTypes/PlaceType";
import { searchBeanMap } from "@wikicasa/common/model/RealEstateSearchBean";
//@ts-ignore
import { Modals } from "@customTypes/Modals";
//@ts-ignore
import { encodePolygon, getMinMaxLatLng, parsePoints } from "@wkWebSrc/js/Utils/MapUtils";
//@ts-ignore
import { isiOSDevice } from "@utils/DeviceDetection";
//@ts-ignore
import { replaceAllTokens } from "@utils/StringUtils";
import { initFirebaseSw, isFirebaseSwInitialized, saveFirebaseToken } from "@wkWebSrc/js/Firebase/FirebaseMessaging/firebaseMessaging";
import { onNotificationsPermissionChange } from "@utils/permissionUtils";
import { defineAsyncComponent, defineComponent } from "vue";
import { useLoggedUserStore } from "@store/LoggedUserStore";
import { usePublicUserMenuStore } from "@store/PublicUserMenuStore";
import { useModalStore } from "@store/ModalStore";
import { isArrNullOrEmpty } from "@utils/ArrayUtils";
import { getCourtAuctionById, getAuctionSaleModeById } from "@services/AuctionAPI";
import { formatDateToddMMYYYY } from "@utils/DateUtils";
import { sendGAEvent } from "@utils/GaEvents";
import { useMetadataStore } from "@wkWebSrc/js/store";
import SaveSearchSuccessModal from "@vmodals/SaveSearchSuccessModal.vue";
export default defineComponent({
  name: "SaveSearchModal",
  components: {
    SaveSearchSuccessModal,
    BaseBtModal,
    BaseInput,
    BaseComplexToggle,
    BaseBadge,
    BaseButton,
    "success-modal": defineAsyncComponent(() => import("./Status/SuccessModal.vue")),
    "limit-modal": defineAsyncComponent(() => import("./Status/LimitModal.vue")),
    "unauthorized-modal": defineAsyncComponent(() => import("./Status/UnauthorizedModal.vue")),
    "limit-saved-modal": defineAsyncComponent(() => import("./Status/LimitSavedModal.vue"))
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    /** If this value is set then it will be used to save the current search, otherwise it will be used the current realEstateBean */
    formDetailInputValues: {
      type: Object
    },
    placeId: {
      type: [Number]
    },
    type: {
      type: String,
      default: "listing"
    },
    /** The serialized realEstateSearchBean which contains info about the current search*/
    serializedResb: {
      type: String,
      required: true
    },
    serializedPlace: {
      type: String
    },
    labels: {
      type: Object,
      required: true
    },
    values: {
      type: Object,
      required: true
    },
    existsTypologyParent: {
      type: Boolean,
      required: true
    },
    emailRegex: {
      type: String
    },
    isAuction: {
      type: Boolean,
      default: false
    }
  },
  emits: ["open-signin-modal", "open-login-modal", "open-email-conf-modal", "closed-modal"],
  setup() {
    var {
      onEnterPressed,
      enterPressedCb
    } = useKeyEnterPressed();
    var {
      isValid
    } = useValidator();
    var {
      isUserLogged
    } = useLoggedUserStore();
    return {
      v$: useVuelidate(),
      onEnterPressed,
      enterPressedCb,
      isValid,
      isUserLogged
    };
  },
  data() {
    return {
      realEstateSearchBean: {},
      show: false,
      place: null,
      /** The -1 value stands for the default value */
      errorCode: -1,
      showErrorMessage: false,
      alertType: "",
      requestData: {
        title: "",
        email: "",
        privacy: false,
        dailyAlert: true
      },
      isLoading: false,
      enableNotifications: false,
      saleModeTypeLabel: "",
      saleCourtTypeLabel: ""
    };
  },
  validations() {
    return {
      requestData: {
        title: {},
        email: {
          required,
          email
        },
        dailyAlert: {
          required
        }
      }
    };
  },
  computed: Object.assign(Object.assign(Object.assign({
    Modals() {
      return Modals;
    },
    cdn() {
      return window["_cdn"];
    },
    placeType() {
      return PLACE_TYPE;
    },
    readAndAcceptedByClicking() {
      var placeholder = "{0}";
      var tokens = this.labels.read_and_accepted_by_clicking.split(placeholder);
      return "".concat(tokens[0], " <span class=\"tw-font-semibold\">").concat(replaceAllTokens(placeholder, {
        "{0}": this.labels.confirm
      }), "</span>").concat(tokens[1]);
    },
    mapURL() {
      var _a, _b;
      var strokeColor = "rgba(51,136,255,1)";
      var fillColor = "rgba(210,227,243,0.75)";
      var latLngs = parsePoints(this.realEstateSearchBean.polygonFromMap);
      if (!this.realEstateSearchBean.polygonFromMap)
        // eslint-disable-next-line max-len
        return "url('https://api.maptiler.com/maps/".concat(MAP_TILER_STYLE, "/static/").concat(((_a = this.place) === null || _a === void 0 ? void 0 : _a.longitude) || "8.9198249", ",").concat(((_b = this.place) === null || _b === void 0 ? void 0 : _b.latitude) || "45.3930345", ",").concat(MAP_TILER_VALUATION_ZOOM, "/").concat(MAP_TILER_VALUATION_IMAGE_SIZE, "@2x.png?key=").concat(MAP_TILER_APIKEY, "')");
      if (latLngs) {
        var minmax = getMinMaxLatLng(latLngs);
        var encoded = encodePolygon(latLngs);
        // eslint-disable-next-line max-len
        return "url('https://api.maptiler.com/maps/".concat(MAP_TILER_STYLE, "/static/").concat(minmax.minx, ",").concat(minmax.miny, ",").concat(minmax.maxx, ",").concat(minmax.maxy, "/544x100@2x.png?path=stroke:").concat(strokeColor, "|width:3|fill:").concat(fillColor, "|enc:").concat(encoded, "&key=").concat(MAP_TILER_APIKEY, "')");
      } else return "";
    },
    MAP_TILER_APIKEY() {
      return MAP_TILER_APIKEY;
    },
    MAP_TILER_VALUATION_CUSTOM_MOBILE_ZOOM() {
      return MAP_TILER_VALUATION_CUSTOM_MOBILE_ZOOM;
    },
    filterLabelsAndCounter() {
      var filterCounter = 0;
      var filterLabels = [];
      var firstLabelFound = false;
      var keyType;
      var floorLabels = {
        GROUND_FLOOR: this.labels["ground_floor"],
        INTERMEDIATE_FLOOR: this.labels["intermediate_floor"],
        TOP_FLOOR: this.labels["top_floor"]
      };
      for (keyType in searchBeanMap) {
        var value = this.realEstateSearchBean[keyType];
        if (!value) continue;
        var {
          from,
          up_to
        } = this.labels;
        var _labels = window["_labels"];
        var filterLabel = "";
        if (!firstLabelFound) {
          switch (keyType) {
            case "bathroomsFrom":
              filterLabel = "".concat(_labels["bathrooms"], ": ").concat(from, " ").concat(value);
              break;
            case "bathroomsTo":
              filterLabel = "".concat(_labels["bathrooms"], ": ").concat(up_to, " ").concat(value);
              break;
            case "roomsFrom":
              filterLabel = "".concat(_labels["rooms"], ": ").concat(from, " ").concat(value);
              break;
            case "roomsTo":
              filterLabel = "".concat(_labels["rooms"], ": ").concat(up_to, " ").concat(value);
              break;
            case "priceFrom":
              filterLabel = "".concat(_labels["price"], ": ").concat(from, " ").concat(value, " \u20AC");
              break;
            case "priceTo":
              filterLabel = "".concat(_labels["price"], ": ").concat(up_to, " ").concat(value, " \u20AC");
              break;
            case "sqMfrom":
              filterLabel = "<span>".concat(_labels["surface"], ": ").concat(from, " ").concat(value, "</span> m<sup>2</sup>");
              break;
            case "sqMto":
              filterLabel = "<span>".concat(_labels["surface"], ": ").concat(up_to, " ").concat(value, "</span> m<sup>2</sup>");
              break;
            case "conditionType":
              // eslint-disable-next-line no-case-declarations
              var propCondition = "propertyCondition_".concat(value);
              if (value != 4)
                //we ignore the condition type equal 4 which is Habitable
                filterLabel = "".concat(_labels[propCondition]);
              break;
            case "floor":
              filterLabel = floorLabels[value];
              break;
            case "auctionMinimumBid":
              filterLabel = "".concat(_labels["minimumBid"], ": ").concat(value, " \u20AC");
              break;
            case "auctionMinimumOfferFrom":
              filterLabel = "".concat(_labels["minimumOffer"], ": ").concat(from, " ").concat(value, " \u20AC");
              break;
            case "auctionMinimumOfferTo":
              filterLabel = "".concat(_labels["minimumOffer"], ": ").concat(up_to, " ").concat(value, " \u20AC");
              break;
            case "auctionProcedureNumber":
              filterLabel = "".concat(_labels["procedureNumber"], ": ").concat(value);
              break;
            case "auctionReferenceYear":
              filterLabel = "".concat(_labels["procedureYear"], ": ").concat(value);
              break;
            case "auctionSaleModeID":
              filterLabel = "".concat(_labels["sellingTypes"], ": ").concat(this.saleModeTypeLabel, " ");
              break;
            case "auctionCourtTypeID":
              filterLabel = "".concat(_labels["court"], ": ").concat(this.saleCourtTypeLabel, " ");
              break;
            case "auctionPublicationDateFrom":
              filterLabel = "".concat(_labels["publicationDateFrom"], ": ").concat(formatDateToddMMYYYY(value), " ");
              break;
            case "auctionPublicationDateTo":
              filterLabel = "".concat(_labels["publicationDateTo"], ": ").concat(formatDateToddMMYYYY(value), " ");
              break;
            case "auctionDateFrom":
              filterLabel = "".concat(_labels["sellingDateFrom"], ": ").concat(formatDateToddMMYYYY(value), " ");
              break;
            case "auctionDateTo":
              filterLabel = "".concat(_labels["sellingDateTo"], ": ").concat(formatDateToddMMYYYY(value), " ");
              break;
            default:
              if (keyType !== "filterOrderId")
                //TODO: for the translation is need to syncronise keyname between searchBeanMap and _labels inside variables.jsp
                filterLabel = typeof value !== "boolean" ? value : searchBeanMap[keyType];
          }
          filterLabels.push(filterLabel);
          firstLabelFound = true;
          continue;
        }
        filterCounter++;
      }
      return {
        filterCounter,
        filterLabels
      };
    },
    isLoggedWithoutConfirmedMail() {
      //@ts-ignore
      return this.isUserLogged && this.mailConfirmed === false;
    },
    anyTypologies() {
      return this.listingTypologies.filter(lt => lt.label === this.labels.allTypologies);
    },
    noGroupTypologies() {
      return this.listingTypologies.filter(lt => !lt.group);
    },
    currentTypologyLabel() {
      var _a, _b, _c;
      var label = "";
      if (((_a = this.realEstateSearchBean.listingTypologyIdList) === null || _a === void 0 ? void 0 : _a.length) == 1) {
        if (this.isNoGroupListingTypologyId(this.realEstateSearchBean.listingTypologyIdList[0])) {
          label = this.getListingTypologyById(this.realEstateSearchBean.listingTypologyIdList[0]).label;
        } else if (this.isAnyListingTypologyId(this.realEstateSearchBean.listingTypologyIdList[0])) {
          // eslint-disable-next-line max-len
          label = "".concat(this.getMacroTypologyLabelById(this.realEstateSearchBean.macroTypologyId), " - ").concat(this.getListingTypologyById(this.realEstateSearchBean.macroTypologyId - 1).label);
        } else {
          label = "".concat(this.getListingTypologyById(this.realEstateSearchBean.macroTypologyId - 1).label);
        }
      } else if (this.realEstateSearchBean.listingTypologyIdList && ((_b = this.realEstateSearchBean.listingTypologyIdList) === null || _b === void 0 ? void 0 : _b.length) > 1) {
        // eslint-disable-next-line max-len
        label = "".concat(this.getMacroTypologyLabelById(this.realEstateSearchBean.macroTypologyId), " - ").concat((_c = this.realEstateSearchBean.listingTypologyIdList) === null || _c === void 0 ? void 0 : _c.length, " ").concat(this.labels.typologies);
      }
      return label || "".concat(window["_macroTypologyDefaultURL"], " - ").concat(window["_labels"].allTypologies);
    },
    listingTypologies() {
      return window["_options"]["listingTypologies"];
    },
    saveSearchTitle() {
      var _a, _b, _c;
      if (!this.labels.defaultSearchTitle) return "";
      var hasZones = this.realEstateSearchBean.zoneIdList && this.realEstateSearchBean.zoneIdList.length > 1;
      var notLocality = this.realEstateSearchBean.placeType != this.placeType.LOCALITY;
      var isZone = this.realEstateSearchBean.placeType == this.placeType.ZONE;
      if (isZone) return ((_a = this.place) === null || _a === void 0 ? void 0 : _a.displayName) || "";
      if (hasZones || notLocality) return this.labels.defaultSearchTitle;
      var indexOfSubstr = this.labels.defaultSearchTitle.indexOf(((_b = this.place) === null || _b === void 0 ? void 0 : _b.cityName) || "");
      var _searchTitle = this.labels.defaultSearchTitle.substring(0, indexOfSubstr);
      //TODO: To remove when we will fix the searchTitle on RElisting (case locality)
      return _searchTitle === this.labels.defaultSearchTitle ? this.labels.defaultSearchTitle : _searchTitle + ((_c = this.place) === null || _c === void 0 ? void 0 : _c.displayName);
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, ["mailConfirmed", "email", "name", "publicUserId"])), mapState(useMetadataStore, ["pageName", "location"])),
  watch: {
    alertType(cur, prev) {
      /* We want to change the boolean value iff there was a previous updating step! */
      if (prev) this.requestData.dailyAlert = !this.requestData.dailyAlert;
    }
  },
  created() {
    return __awaiter(this, void 0, void 0, function* () {
      this.setLocation("Modale salva ricerca");
      if (this.isUserLogged) this.enableNotifications = !isNotificationDenied();
      // in modalità mobile non sarà rilevato questa modifica se non al submit
      onNotificationsPermissionChange(_ref => {
        var {
          detail
        } = _ref;
        if (!this.isUserLogged) return;
        if (detail.permissionState === "granted") this.enableNotifications = true;else if (detail.permissionState === "denied") this.enableNotifications = false;
      });
      //@ts-ignore
      this.onEnterPressed(this.submitForm);
      this.realEstateSearchBean = JSON.parse(this.serializedResb);
      var placeID = this.realEstateSearchBean.placeId || parseInt("".concat(this.placeId), 10);
      this.place = this.serializedPlace ? JSON.parse(this.serializedPlace) : yield getPlaceFromPlaceID(placeID);
      this.requestData.title = decodeTextWithEntities(this.saveSearchTitle);
      if (this.realEstateSearchBean["auctionSaleModeID"]) yield this.getSaleModeTypeLabel(this.realEstateSearchBean["auctionSaleModeID"]);
      if (this.realEstateSearchBean["auctionCourtTypeID"]) yield this.getCourtTypeLabel(this.realEstateSearchBean["auctionCourtTypeID"]);
      if (this.formDetailInputValues) {
        var {
          cityId,
          zoneId,
          provinceId
        } = this.formDetailInputValues;
        this.realEstateSearchBean.cityId = cityId;
        this.realEstateSearchBean.zoneId = zoneId;
        this.realEstateSearchBean.provinceId = provinceId;
      }
    });
  },
  mounted() {
    this.show = this.showModal;
  },
  methods: Object.assign(Object.assign(Object.assign({
    isArrNullOrEmpty,
    isiOSDevice,
    getListingTypologyById(id) {
      return this.listingTypologies.filter(lt => lt.listingTypologyId === id)[0];
    },
    openSignInModal() {
      this.$emit("open-signin-modal");
    },
    openPrivacyDisclaimer() {
      window.open("/privacy", "_blank", "scrollbars=yes, width=550, height=600");
    },
    showLoginModal() {
      this.$emit("open-login-modal");
    },
    getMacroTypologyLabelById(macroTypologyId) {
      return this.labels["macroTypology".concat(macroTypologyId, "Label")];
    },
    onConfirmEmailBtt() {
      this.isLoading = true;
      resendConfirmationEmail(this.email).then(() => {
        this.openEmailConfirmedModal();
        this.show = false;
      }).catch(() => {
        //not handled...
      }).finally(() => {
        this.isLoading = false;
      });
    },
    isAnyListingTypologyId(listingTypologyId) {
      var listingTypology = this.getListingTypologyById(listingTypologyId);
      return this.anyTypologies.some(lt => lt.listingTypologyId === listingTypology.listingTypologyId);
    },
    isNoGroupListingTypologyId(listingTypologyId) {
      var listingTypology = this.getListingTypologyById(listingTypologyId);
      return this.noGroupTypologies.some(lt => lt.listingTypologyId === listingTypology.listingTypologyId);
    },
    checkNotificationPermissions() {
      return __awaiter(this, void 0, void 0, function* () {
        //In case the user is not logged, then we won't check the permissions (also the sw is not registered)
        if (!this.isUserLogged) return;
        this.enableNotifications = !isNotificationDenied();
        if (!this.enableNotifications) return;
        /* In case the notifications are enabled, we check if the sw has been initialized, if not, we initialize it and save the current token*/
        if (!isFirebaseSwInitialized()) {
          yield initFirebaseSw();
          yield saveFirebaseToken();
        }
      });
    },
    submitForm() {
      var _a;
      return __awaiter(this, void 0, void 0, function* () {
        !isiOSDevice() && (yield this.checkNotificationPermissions());
        //@ts-ignore
        if (this.isUserLogged) {
          this.requestData.privacy = true;
          this.requestData.email = this.email;
        }
        this.v$.$touch(); //Touching all fields!
        if (this.v$.$invalid) {
          return false;
        }
        try {
          this.isLoading = true;
          /* Is pointless to enable the push notifications to ios devices since the web push notifications are too way recent */
          if (isiOSDevice()) this.enableNotifications = false;
          sendGAEvent("mail_alert_save", {
            event_location: "".concat(this.pageName, " - ").concat(this.location),
            real_estate_place_id: (_a = this.placeId) !== null && _a !== void 0 ? _a : null
          });
          //Caveat: hourly stands for immediate notification which corresponds to dailyAlert === false.
          yield this.addSaveSearch({
            email: this.requestData.email,
            title: this.requestData.title,
            hourly: !this.requestData.dailyAlert,
            resb: this.realEstateSearchBean,
            pushNotifications: this.enableNotifications
          });
          //Showing success modal!
          this.errorCode = 200;
          return true;
        } catch (err) {
          console.error(err);
          var {
            response
          } = err;
          if (!response) {
            //Generic error
            this.showErrorMessage = true;
            return false;
          }
          //Showing error modal or default error message
          if (response.status === 401 || response.status === 405 || response.status === 409 || response.status === 412) this.errorCode = response.status;else
            //Generic error
            this.showErrorMessage = true;
          return false;
        } finally {
          this.isLoading = false;
        }
      });
    },
    closedModal() {
      this.$emit("closed-modal");
    },
    openEmailConfirmedModal() {
      this.$emit("open-email-conf-modal");
    },
    getSaleModeTypeLabel(value) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          this.saleModeTypeLabel = (yield getAuctionSaleModeById(value)).saleModeName;
        } catch (e) {
          console.error(e);
        }
      });
    },
    getCourtTypeLabel(value) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          this.saleCourtTypeLabel = (yield getCourtAuctionById(value)).courtName;
        } catch (e) {
          console.error(e);
        }
      });
    }
  }, mapActions(useModalStore, ["setShowModal"])), mapActions(usePublicUserMenuStore, ["addSaveSearch"])), mapActions(useMetadataStore, ["setLocation"]))
});